import { useState, useEffect } from 'react';
import './Samples.css';
import './Members.css';
import videos from '../videoData';
import VideoDetails from '../VideoDetails';
import VideoCard from '../VideoCard';
import Umbrella from '../../static/images/video_thumbs/kinder/umbrella.png';
import Catapults from '../../static/images/video_thumbs/fourth/catapults.png';
import PurchaseCard from '../PurchaseCard';

function Samples() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // controls which video to display details page from user click
    const [showVideoDetails, setShowVideoDetails] = useState(null);

    const backButtonClicked = () => {
        setShowVideoDetails(null);
        window.scrollTo(0, 0);
    };

    const handleVideoClick = (e) => {
        const videoIndex = e.currentTarget.getAttribute('video-index');
        setShowVideoDetails(
            <>
                <VideoDetails
                    videoTitle={
                        videoIndex === '0' ? 'Design an Umbrella' : 'Catapults'
                    }
                    videoUrl={
                        videoIndex === '0' ? videos[0][0].url : videos[4][1].url
                    }
                    videoResourceUrl={
                        videoIndex === '0'
                            ? videos[0][0].resource
                            : videos[4][1].resource
                    }
                    videoIndex={videoIndex} />
                <button
                    type="button"
                    className="members__back-button"
                    onClick={() => backButtonClicked()}>
                    Back to Videos
                </button>
            </>,
        );
    };

    return (
        <div className="samples-container">
            <div className="samples__inner-container">
                {!showVideoDetails && (
                    <div className="samples__video-title">Sample Lessons</div>
                )}
                <div
                    className={
                        showVideoDetails
                            ? 'samples__videos'
                            : 'samples__videos cards-gap cards-padding'
                    }>
                    {showVideoDetails || (
                        <>
                            <VideoCard
                                key={videos[0][0].id}
                                videoIndex={0}
                                thumbnail={Umbrella}
                                title="Design an Umbrella"
                                description={videos[0][0].description}
                                handleVideoClick={(event) => handleVideoClick(event)} />
                            <VideoCard
                                key={videos[4][1].id}
                                videoIndex={1}
                                thumbnail={Catapults}
                                title="Catapults"
                                description={videos[4][1].description}
                                handleVideoClick={(event) => handleVideoClick(event)} />
                        </>
                    )}
                </div>
            </div>
            <div style={{ margin: '32px', textAlign: 'center' }}>
                <PurchaseCard />
            </div>
        </div>
    );
}

export default Samples;
